export { Spinner } from '@chakra-ui/react';
export type { SpinnerProps } from '@chakra-ui/react';
